import cuesheetHoc from './cuesheet.hoc';
import { ViewTypes } from 'shared/constants/CuesheetViews';

export default cuesheetHoc(ViewTypes.Loose);
